import { render } from "./SaveLabel.vue?vue&type=template&id=7eb78251&scoped=true&ts=true"
import script from "./SaveLabel.vue?vue&type=script&lang=ts"
export * from "./SaveLabel.vue?vue&type=script&lang=ts"

import "./SaveLabel.vue?vue&type=style&index=0&id=7eb78251&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb78251"]])

export default __exports__